import React, { useEffect } from 'react';
import { debounce } from 'lodash';
import * as echarts from 'echarts/lib/echarts';
import ResizeObserver from 'resize-observer-polyfill';

export default (divRef: React.RefObject<HTMLDivElement>): void => {
  const handleResize = React.useCallback(() => {
    if (!divRef.current) {
      return;
    }
    const echartInstance = echarts.getInstanceByDom(divRef.current);
    if (echartInstance) {
      debounce(() => { echartInstance.resize(); }, 100);
    }
    echartInstance.resize();
  }, [divRef]);

  useEffect(() => {
    if (!divRef.current) {
      return;
    }
    // Auto resize
    const resizeObserver = new ResizeObserver(handleResize);
    resizeObserver.observe(divRef.current);
    return () => {
      if (!divRef.current) {
        return;
      }
      resizeObserver.unobserve(divRef.current);
    };
  }, [handleResize]);
};
